<template>
  <div class="wrap">
    <div class="pop-login">
      <div class="box">
        <div class="hd">微信登录</div>
        <div class="bd">
          <div class="img-box">
            <img :src="qrcodeUrl || preLodingImg" />
          </div>
          <div class="desc">用微信扫一扫登录</div>
        </div>
        <div class="ft">「关注公众号」自动登录</div>
      </div>
      <a href="javascript:;" @click="openUrl('//www.xiaohudi.com')"
        >小虎弟官网</a
      >
    </div>
    <!-- <div class="box login-box" :class="{'flip': bHasUserInfo}">
      <div class="paper back">
        <div class="hd">升级浏览器</div>
        <div class="bd">
          <div class="info">您的浏览器过于老旧，不支持机器人的运行。</div>
          <div class="icon">
            <img src="@/views/login/image/browser-qq.png" />
          </div>
          <div class="txt">推荐使用：QQ浏览器</div>
          <a
            class="button"
            href="https://dldir1.qq.com/invc/tt/QQ/SEM/QQBrowser_Setup_QB10_10026011.exe"
          >安装QQ浏览器</a>
        </div>
        <div class="ft"></div>
      </div>
      <div class="paper front">
        <div class="hd">微信登录</div>
        <div class="bd" :class="isShowRefreshBtn?'expire':''" @click="btnRefresh">
          <div class="img-box">
            <img :src="qrcodeUrl" />
          </div>
          <div class="txt"></div>
        </div>
        <div class="ft">「关注公众号」自动登录</div>
      </div>
    </div>-->
  </div>
</template>

<script>
import {
  getSignInQrcode,
  getSignInStatus,
  userInfo,
  consumeFCode,
} from "@/api";
import QRCode from "qrcode";
import { Message } from "element-ui";
import preLodingImg from "@/assets/pic/qrcode-loading.png";
import { commonFuc } from "@/mixins/commonFuc";
import { mapActions } from "vuex";

export default {
  mixins: [commonFuc],
  data() {
    return {
      qrcodeUrl: "",
      bHasUserInfo: false,
      loopDurationTime: 90,
      loginCode: "",
      fcode: "",
      user: {},
      hello: "world!",
      countDownTimer: null,
      coutDownNum: 0,
      isShowRefreshBtn: false,
      isWeixin: navigator.userAgent.match(/MicroMessenger/i),
      isPC: !navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ),
      preLodingImg: preLodingImg,
    };
  },
  methods: {
    ...mapActions(["changeLoadingStatus"]),
    countDown() {
      this.clearCountDown();
      this.countDownTimer = setInterval(() => {
        this.loopDurationTime--;
        this.toLoopLogin();
        // if (this.loopDurationTime <= 0) {
        //   this.loopDurationTime = 90;
        //   this.clearCountDown();
        //   this.coutDownNum++;
        //   if (this.coutDownNum != 3) {
        //     this.checkLogin();
        //   } else {
        //     this.isShowRefreshBtn = true;
        //   }
        // }
      }, 1000);
    },
    clearCountDown() {
      clearInterval(this.countDownTimer);
      this.countDownTimer = null;
    },
    btnRefresh() {
      if (this.isShowRefreshBtn) {
        this.coutDownNum = 0;
        this.checkLogin();
        this.isShowRefreshBtn = false;
      }
    },
    hasLogin(user) {
      this.user = user;
      user.portrait = user.portrait || localStorage.getItem("avatar");
      user.name = user.name || localStorage.getItem("user_name");
      this.$store.commit("UPDATE_USER", user);
      console.log(">>>>>login");
      let query = this.$router.currentRoute.query;
      let redirect = query.redirect;
      if (redirect) {
        this.$router.replace({ path: redirect, query: query });
      } else if (!user.activated) {
        this.$router.replace("/guideFcode");
        return;
      } else {
        this.$router.replace("/robotManager");
      }
    },
    getLoginCode() {
      getSignInQrcode(null, { notify: false }).then((res) => {
        if (res.code == 0) {
          let code = res.data.code;
          this.loginCode = code;
          this.qrcodeUrl = res.data.url;
          // this.loopTime = new Date().getTime();
          this.countDown();
        }
      });
    },
    toLoopLogin() {
      getSignInStatus(
        {
          login_code: this.loginCode,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          let status = res.data.status;
          if (status === 1) {
            //登录成功
            localStorage.setItem("sid", res.data.sid);
            localStorage.setItem("avatar", res.data.portrait);
            localStorage.setItem("user_name", res.data.name);
            this.clearCountDown();
            this.checkLogin();
          } else if (status === 0) {
            //登录中
          } else if (status === -1) {
            //超时
            // if (new Date().getTime() - this.loopTime < this.loopDurationTime) {
            //   setTimeout(() => {
            //     this.toLoopLogin();
            //   }, 2000);
            // }
          }
        }
      });
    },
    quit() {
      localStorage.removeItem("sid");
      localStorage.removeItem("avatar");
      localStorage.removeItem("user_name");
      location.href = "/login";
    },
    checkLogin() {
      this.changeLoadingStatus(false);
      userInfo(null, { notify: false })
        .then((res) => {
          if (res.code == -2050) {
            let searchSid = this.getParameter("sid");
            let redirect = this.getParameter("redirect");
            let t = this.$route.query.t;
            let n = this.$route.query.n;
            if (searchSid) {
              localStorage.setItem("sid", searchSid);
              location.replace(
                location.href.split("?")[0] +
                  (redirect ? "?redirect=" + redirect : "") +
                  (t ? (redirect ? "&t=" + t : "?t=" + t) : "") +
                  (n ? "&n=" + n : "")
              );
              return;
            }
            if (this.isWeixin) {
              //不管是否有sid,可能sid已经过期了,无效了,就强制跳转登录
              location.replace(
                `https://api.xiaohudi.com/wechat/oauth?callbackUrl=${encodeURIComponent(
                  location.href
                )}`
              );
            } else {
              this.getLoginCode();
            }
          } else {
            this.hasLogin(res.data);
          }
        })
        .catch((e) => {
          let searchSid = this.getParameter("sid");
          let redirect = this.getParameter("redirect");
          let t = this.$route.query.t;
          let n = this.$route.query.n;
          if (searchSid) {
            localStorage.setItem("sid", searchSid);
            location.replace(
              location.href.split("?")[0] +
                (redirect ? "?redirect=" + redirect : "") +
                (t ? (redirect ? "&t=" + t : "?t=" + t) : "") +
                (n ? "&n=" + n : "")
            );
            return;
          }
          if (this.isWeixin) {
            location.replace(
              `https://api.xiaohudi.com/wechat/oauth?callbackUrl=${encodeURIComponent(
                location.href
              )}`
            );
          } else {
            this.getLoginCode();
          }
        });
    },
    payFcode() {
      if (this.fcode) {
        consumeFCode({
          fcode: this.fcode,
        }).then((res) => {
          if (res.code == 0) {
            this.$router.replace("/config");
          } else {
            if (res.code == 20004) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码错误</strong><p style="margin-top: 5px;">F码错误请重新输入</p>',
              });
              // '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
            }
            if (res.code == 20005) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是公会版F码，请下载公会版使用</p>',
              });
            }
            if (res.code == 20006) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">新手体验码每个账号只能使用一张</p>',
              });
            }
            if (res.code == 20007) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是单功能F码，无法用于新增机器人</p>',
              });
            }
            if (res.code == 20008) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已被使用，如有疑问，请联系客服</p>',
              });
            }
            if (res.code == 20015) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验码仅限原账号使用</p>',
              });
            }
            if (res.code == 20016) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已过期，体验卡请在24小时内使用</p>',
              });
            }
            if (res.code == 20017) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验卡仅限给发码机器人使用</p>',
              });
            }
          }
        });
      } else {
        Message({
          showClose: true,
          message: "请输入F码，完成注册！",
        });
      }
    },
    getParameter(sProp) {
      var re = new RegExp(sProp + "=([^&]*)", "i");
      var a = re.exec(document.location.search);
      if (a == null) return null;
      return a[1];
    },
  },
  created() {
    this.checkLogin();
    let UA = window.navigator.userAgent;
    console.log(UA.indexOf(".NET"));
    if (
      (UA.indexOf(".NET") != -1 && UA.indexOf("QQBrowser") == -1) ||
      UA.indexOf("Edge") != -1
    ) {
      this.bHasUserInfo = true;
    } else {
      if (~UA.indexOf(".NET") && ~UA.indexOf("QQBrowser")) {
        this.$message({
          title: "提示",
          message: "QQ浏览器兼容模式不支持，请切换极速模式",
          type: "error",
        });
      }
    }
  },
  destroyed() {
    this.clearCountDown();
  },
};
</script>
